const getters = {
    sidebar: state => state.app.sidebar,
    token: state => state.user.token,
    avatar: state => state.user.avatar,
    name: state => state.user.name,
    roles: state => state.user.roles,
    userInfo:state=> state.user.userInfo,
    fileToken: state=> state.user.fileToken,
    permission_routers: state => state.permission.routers,
    routerStatus: state => state.permission.routerStatus,
    addRouters: state => state.permission.addRouters,
    errorNo:state => state.error.errorNo,
    dictionary: state => state.dictionary.dicStorage
};
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js